import { render, staticRenderFns } from "./section-results-info.vue?vue&type=template&id=ea6f8aa2&scoped=true&"
import script from "./section-results-info.vue?vue&type=script&lang=js&"
export * from "./section-results-info.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ea6f8aa2",
  null
  ,true
)

export default component.exports